import React, { Suspense } from "react";
import { ArrowDown } from "lucide-react";
import ThreeScene from "./ThreeScene";
import { HERO } from "../mock/mock";

export default function Hero() {
  const scrollToMethod = () => {
    const el = document.querySelector("#metodologie");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" className="theme-dark relative min-h-screen w-full overflow-hidden bg-[var(--pl-bg)] text-[var(--pl-text)] flex flex-col justify-center">
      {/* Giant PX watermark */}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-end pr-[4vw] select-none">
        <span
          className="font-display font-black text-outline leading-none text-[38vw] md:text-[30vw]"
          style={{ opacity: "var(--pl-watermark-opacity)" }}
        >
          PX
        </span>
      </div>

      {/* 3D scene */}
      <div className="pointer-events-none absolute inset-y-0 right-0 w-full md:w-[62%] z-[1]">
        <Suspense fallback={null}>
          <ThreeScene />
        </Suspense>
      </div>

      {/* Hero content */}
      <div className="section-pad relative z-[2] pt-24">
        <h1 className="font-display font-black uppercase leading-[1.06]">
          <span className="hero-title-anim block text-[var(--pl-text)] text-[clamp(2.4rem,6.2vw,5.6rem)] tracking-[-0.03em]" style={{ animationDelay: "0.15s" }}>
            {HERO.title}
          </span>
        </h1>
        <p
          className="hero-word-anim mt-7 md:mt-9 font-display font-medium text-[var(--pl-text)] text-[clamp(1.25rem,3.2vw,2.35rem)] leading-tight"
          style={{ animationDelay: "0.6s" }}
        >
          {HERO.eyebrow}
        </p>
      </div>

      {/* Bottom row */}
      <div className="section-pad relative z-[2] mt-14 md:mt-20 pb-16 flex flex-col md:flex-row md:items-end md:justify-between gap-8">
        <p className="max-w-md text-[16px] leading-relaxed text-[var(--pl-text-2)] hero-anim md:text-[17px]" style={{ animationDelay: "1.05s" }}>
          {HERO.description}
        </p>
        <button onClick={scrollToMethod} className="group flex items-center gap-4 self-start md:self-auto hero-anim" style={{ animationDelay: "1.2s" }}>
          <span className="flex items-center justify-center w-11 h-11 border border-[var(--pl-line-strong)] group-hover:bg-[var(--pl-inverse-bg)] group-hover:text-[var(--pl-inverse-text)] transition-all duration-300">
            <ArrowDown size={16} className="animate-bounce" />
          </span>
          <span className="mono-label group-hover:text-[var(--pl-text)] transition-colors">{HERO.cta}</span>
        </button>
      </div>
    </section>
  );
}
